exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body-item[data-v-6c0205f2]{overflow:hidden;position:relative;margin-top:15px}.body-title[data-v-6c0205f2]{background:#5cadff;padding:6px;position:absolute;color:#fff;margin-left:15px}.body-content[data-v-6c0205f2]{line-height:30px;font-size:15px;min-height:70px;border:1px solid #ddd;border-radius:5px;margin-top:15px;padding:0 15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-6c0205f2","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/medDoc/index.vue
// module id = 8c9z
// module chunks = 0